<script lang="ts">
  import { downloadFile, getErrorMessage } from '$lib/api/client';
  let { asset, revision }: { asset: number; revision: number } = $props();
  let busy = $state(false), error = $state('');
  async function download() {
    busy = true; error = '';
    try { await downloadFile(`/catalogue-assets/${asset}/revisions/${revision}/download`, {}, `toyama-${asset}-${revision}.pdf`); }
    catch (e) { error = getErrorMessage(e); } finally { busy = false; }
  }
</script>
<section class="tym-page space-y-4"><h2 class="tym-section-title">Private catalogue PDF</h2><p>This link requires a signed-in account with access to this document.</p><button class="btn-primary" disabled={busy} onclick={download}>{busy ? 'Downloading…' : 'Download PDF'}</button>{#if error}<p role="alert">{error}</p>{/if}</section>
